module.exports = __webpack_public_path__ + "a16df4c1f67b42fd429f021139169c92.png";